// @ts-strict-ignore
import React, { PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, RequestError } from '@node-space/ui-components'
import { ExternalLink } from 'components/ExternalLink/ExternalLink'
import { ExternalLinks } from 'constants/links'

export interface RequestErrorStatusCardProps extends PropsWithChildren {
  sentryTraceId?: string
  onReload?: () => void
}

export const RequestErrorStatusCard = ({
  children,
  sentryTraceId,
  onReload,
}: RequestErrorStatusCardProps) => {
  const { t } = useTranslation()

  return (
    <RequestError
      description={
        <>
          {children ?? (
            <p className="text-body-regular text-foreground-prominent text-center">
              {`${t('errorMessages.weApologiseForInconvenience')} ${t('errorMessages.pleaseTryTo')} `}
              {onReload ? (
                <Button variant="ghost" noPadding onClick={onReload}>
                  {t('errorMessages.reloadData')}
                </Button>
              ) : (
                <Button variant="ghost" noPadding onClick={() => window.location.reload()}>
                  {t('errorMessages.reload')}
                </Button>
              )}
              {`. ${t('errorMessages.ifTheProblemPersists')}, `}
              <ExternalLink href={ExternalLinks.CONTACT_SUPPORT}>
                {t('errorMessages.contactSupport')}
              </ExternalLink>
              {` ${t('errorMessages.tryLater')}.`}
            </p>
          )}
          {sentryTraceId && (
            <p className="text-body-regular-small text-foreground-subdued pt-6">
              {t('errorMessages.traceId')}: {sentryTraceId}
            </p>
          )}
        </>
      }
    />
  )
}
